// PartBPage3/index.jsx - Part B Page 3 (Student Editor - View Only Teacher Assessment)
import React from 'react';
import { useActivityContext } from '../index';

const PartBPage3 = () => {
  const { activity } = useActivityContext();
  // CORRECT PATH: activity.part_b.page_3.stage1
  const stage1Data = activity?.part_b?.page_3?.stage1 || {
    awareness: [],
    sensitivity: [],
    creativity: [],
    comments: ''
  };

  const awarenessItems = [
    "Guiding questions created by the learner demonstrate a clear understanding of project goals and objectives.",
    "The learner identifies potential challenges and proposes solutions.",
    "The learner develops a plan for project execution.",
    "The learner can clearly communicate project ideas and plans to other group members.",
    "The learner can successfully identify existing content knowledge and gaps in their understanding."
  ];

  const sensitivityItems = [
    "The learner actively seeks input from all group members during planning.",
    "The learner tries to support fair distribution of tasks and responsibilities including all genders.",
    "The learner ensures that decisions are made collaboratively.",
    "The learner actively maintains a shared understanding with the group.",
    "The learner can handle different opinions in the group respectfully."
  ];

  const creativityItems = [
    "The learner is able to brainstorm about project execution and presentation.",
    "The learner demonstrates curiosity in proposing sources of material beyond conventional resources.",
    "The learner demonstrates initiative in proposing solutions to possible barriers.",
    "The learner can provide creative input to decide the roles of group members.",
    "The learner can go beyond the defined features of the project prompt/task and add a unique element to it."
  ];

  const renderCheckboxSection = (title, items, category) => {
    const checkedIndices = stage1Data[category] || [];
    const total = checkedIndices.length;

    return (
      <div style={{ marginBottom: '16px' }}>
        <div style={{
          backgroundColor: '#F4A460',
          color: 'white',
          padding: '8px 12px',
          fontWeight: 'bold',
          fontSize: '14px',
          marginBottom: '8px'
        }}>
          {title}
        </div>
        <div style={{
          backgroundColor: '#FFE5D5',
          padding: '12px'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '6px',
              fontSize: '14px',
              lineHeight: '1.4',
              color: '#666'
            }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #999',
                marginRight: '8px',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '1px',
                fontSize: '12px',
                backgroundColor: '#f9f9f9'
              }}>
                {checkedIndices.includes(index) && '✓'}
              </div>
              <span>{item}</span>
            </div>
          ))}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: '10px',
            fontSize: '14px',
            fontWeight: 'bold'
          }}>
            <span style={{ marginRight: '10px' }}>Total number of (✓):</span>
            <div style={{
              width: '35px',
              height: '35px',
              border: '3px solid #F4824C',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '14px'
            }}>
              {total}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderText = (text) => {
    if (!text || text.trim() === '') return <div style={{ fontSize: '14px', color: '#999', fontStyle: 'italic' }}>Not filled by teacher yet</div>;
    return <div style={{ fontSize: '14px', lineHeight: '1.5', whiteSpace: 'pre-wrap', color: '#666' }}>{text}</div>;
  };

  return (
    <div style={{
        width: '100%',
        maxWidth: '1400px',
        minHeight: '80vh',
        margin: '0 auto',
        padding: '40px',
        backgroundColor: 'white',
        fontFamily: "'Poppins', Arial, sans-serif",
        position: 'relative',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        {/* Decorative Corners */}


        {/* Header */}
        <div style={{
          backgroundColor: '#F4824C',
          color: 'white',
          fontSize: '14px',
          fontWeight: 'bold',
          padding: '10px',
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          Stage 1
        </div>

        {/* Info Note */}
        <div style={{
          backgroundColor: '#E3F2FD',
          borderLeft: '4px solid #2196F3',
          padding: '10px 15px',
          marginBottom: '16px',
          fontSize: '12px',
          color: '#1565C0'
        }}>
          📘 This page contains teacher assessment. Your teacher will fill this section after reviewing your work.
        </div>

        {/* Teacher Assessment Label */}
        <div style={{
          backgroundColor: '#F4824C',
          color: 'white',
          padding: '8px 14px',
          fontWeight: 'bold',
          fontSize: '12px',
          display: 'inline-block',
          marginBottom: '12px'
        }}>
          Teacher Assessment
        </div>

        <div style={{
          fontSize: '14px',
          fontWeight: 'bold',
          marginBottom: '12px'
        }}>
          Tick (✓) all statements that apply.
        </div>

        {renderCheckboxSection('Awareness', awarenessItems, 'awareness')}
        {renderCheckboxSection('Sensitivity', sensitivityItems, 'sensitivity')}
        {renderCheckboxSection('Creativity', creativityItems, 'creativity')}

        {/* Comments Section */}
        <div style={{ marginTop: '20px' }}>
          <div style={{
            fontWeight: 'bold',
            fontSize: '14px',
            marginBottom: '8px'
          }}>
            Brief comments and pedagogical interventions recommended:
          </div>
          <div style={{
            backgroundColor: '#FFE5D5',
            padding: '12px',
            minHeight: '80px',
            borderRadius: '4px'
          }}>
            {renderText(stage1Data.comments)}
          </div>
        </div>

        {/* Bottom Corners */}


      </div>

  );
};

export default PartBPage3;
